import { Component, OnInit, OnDestroy } from '@angular/core';
import { GS1Document } from '../../models/document.model';
import { DocumentService } from '../../services/document.service';

@Component({
    selector: 'footer-comp',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {

    

    constructor(private documentService: DocumentService) {
    }
        
    ngOnInit() {        
    }
    
    ngOnDestroy(): void {
    }

    async CGU() {
        let doc: GS1Document = await this.documentService.getCGU();
        await this.documentService.DownloadDocument(doc.idDoc);
    }
    async PolitiqueConfidentialite() {
        let doc: GS1Document = await this.documentService.getPolitiqueConfidentialite();
        await this.documentService.DownloadDocument(doc.idDoc);
    }
}